import { useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../lib/api/client";
import { useTenantSlug } from "../lib/tenant";
import { DEFAULT_BRAND } from "../lib/theme";
import { readableOn, tint } from "../lib/color";
import { CheckIcon } from "../components/icons";

// Standalone phone-handoff screen — rendered outside the themed TenantLayout (opened on a
// second device), so colours use the default brand literal rather than CSS variables.
export function MobileUploadPage() {
  const { pairingId = "" } = useParams();
  const tenantSlug = useTenantSlug();
  const [state, setState] = useState<"idle" | "uploading" | "done" | "error">("idle");

  async function onFile(e: React.ChangeEvent<HTMLInputElement>) {
    const file = e.target.files?.[0];
    if (!file) return;
    setState("uploading");
    try {
      const ticket = await api.createUploadTicket(tenantSlug, file);
      await api.uploadToTicket(ticket, file);
      await api.completePairing(tenantSlug, pairingId, ticket.publicUrl);
      setState("done");
    } catch {
      setState("error");
    }
  }

  return (
    <div style={{ fontFamily: "system-ui, -apple-system, sans-serif", minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 24, textAlign: "center", gap: 16 }}>
      {state === "done" ? (
        <>
          <div style={{ width: 72, height: 72, borderRadius: "50%", background: tint(DEFAULT_BRAND, 0.85), color: DEFAULT_BRAND, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <CheckIcon size={36} />
          </div>
          <h2>Photo sent!</h2>
          <p style={{ color: "#666" }}>Return to your computer to continue.</p>
        </>
      ) : (
        <>
          <h2>Take a photo of your home</h2>
          <label style={{ background: DEFAULT_BRAND, color: readableOn(DEFAULT_BRAND), padding: "14px 22px", borderRadius: 999, fontWeight: 600, cursor: "pointer" }}>
            {state === "uploading" ? "Sending…" : "Open camera"}
            <input type="file" accept="image/*" capture="environment" onChange={onFile} style={{ display: "none" }} />
          </label>
          {state === "error" && <p style={{ color: "#b91c1c" }}>Upload failed — please try again.</p>}
        </>
      )}
    </div>
  );
}
